'use client';

import { Container, Loader } from '@crehana/compass.ui';

export default function Loading() {
  // Or a custom loading skeleton component
  return (
    <Container>
      <div
        className="tw-col-span-12 tw-flex tw-justify-center tw-items-center"
        style={{
          height: '50vh',
        }}
      >
        <Loader />
      </div>
    </Container>
  );
}
